export const DEFAULT_FUNDER_DETAILS = {
  funderId: 0,
  utilisationNumber: "",
  accountName: "",
  accountNumber: "",
  bsb: "",
};
